import { useState as l, useEffect as i } from "react";
import { spUiLibLogger as u } from "./logger.js";
const o = u.extend("local-storage-hook");
function w(t, n) {
  const [a, s] = l(() => {
    try {
      const r = window.localStorage.getItem(t);
      return r == null ? n : JSON.parse(r);
    } catch (r) {
      o("Error reading from localStorage:", r);
    }
    return n;
  }), c = (r) => {
    try {
      const e = r instanceof Function ? r(a) : r;
      s(e), window.localStorage.setItem(t, JSON.stringify(e));
    } catch (e) {
      o("Error writing to localStorage:", e);
    }
  };
  return i(() => {
    const r = (e) => {
      if (!(e.key !== t || e.newValue == null))
        try {
          s(JSON.parse(e.newValue));
        } catch (g) {
          o("Error parsing storage event:", g);
        }
    };
    return window.addEventListener("storage", r), () => {
      window.removeEventListener("storage", r);
    };
  }, [t]), [a, c];
}
export {
  w as useLocalStorage
};
